
import {Component, Prop, Vue} from 'vue-property-decorator';

/**
 * Takip Hazırla — Ekran Ortası Sabit İlerleme Barı
 *
 * Verisini `storeModule` ile belirtilen Vuex modülünden okur.
 * - Normal takip hazırlama: `takipHazirla` (varsayılan)
 * - MTS takip hazırlama:    `mtsTakipHazirla`
 *
 * Görünürlük: SADECE toplu işlem (tevzi alma / dayanak yükleme — isSubmitting / onFly)
 * sürerken. XML parse / dosya sorgulama aşamasında gösterilmez.
 */
@Component({})
export default class TakipHazirlaProgressBar extends Vue {
  /** Hangi Vuex modülünden okunacağı (namespace) */
  @Prop({type: String, default: 'takipHazirla'}) readonly storeModule!: string;

  /** Namespaced getter okuma yardımcısı */
  private g<T>(name: string, fallback: T): T {
    const value = this.$store.getters[`${this.storeModule}/${name}`];
    return value === undefined || value === null ? fallback : value;
  }

  get isSubmitting(): boolean {
    return this.g<boolean>('isSubmitting', false);
  }

  /** MTS modülünde ayrı bir `onFly` getter'ı vardır; normal modülde yoktur (fallback false). */
  get onFly(): boolean {
    return this.g<boolean>('onFly', false);
  }

  get durumAciklamasi(): string {
    return this.g<string>('durumAciklamasi', '');
  }

  get sorgulanmaDurumu(): number {
    return this.g<number>('sorgulanmaDurumu', 0);
  }

  /**
   * Sadece toplu işlem (tevzi alma / dayanak yükleme) sürerken görünür.
   * XML parse / dosya sorgulama (isParsing) aşamasında BİLİNÇLİ olarak gösterilmez —
   * o aşamada tablo üstündeki inline "Takip Hazırlanıyor" kartı zaten bilgilendirir.
   */
  get isVisible(): boolean {
    return this.isSubmitting || this.onFly;
  }

  /** 0-100 arası tam sayı yüzde */
  get yuzde(): number {
    return Math.min(100, Math.max(0, Math.ceil(this.sorgulanmaDurumu)));
  }

  /**
   * Başlık: durum açıklaması (örn. "#12 dosya için tevzi alınıyor... (12/45)").
   */
  get title(): string {
    return this.durumAciklamasi || 'İşlem Devam Ediyor';
  }

  get subtitle(): string {
    return 'Lütfen işlem tamamlanana kadar sayfayı yenilemeyiniz.';
  }
}
